<template>
	<v-container grid-list-xl v-if="show">
		<v-layout
			row
			justify-center
		>
			<v-flex
				xs12
				md8
				pa-0
			>
				<NewItem
					v-if="canEdit"
					ref="newItem"
					button-title="New Custom Data"
				>
					<template slot="form">
						<CustomFieldForm
							@close="$refs.newItem.close()"
						/>
					</template>
				</NewItem>
			</v-flex>
		</v-layout>
		
		<CustomFieldsIterator
			:items="customDatas.models"
			@update="updateField"
			@disable="disableField"
		/>	
		
		<v-dialog
			v-model="showEditDialog"
			max-width="800"
		>
			<v-card>
				<v-container grid-list-xl>
					<CustomFieldForm
						:edit-custom-field="editField"
						@close="showEditDialog = false"
					/>
				</v-container>
			</v-card>
		</v-dialog>
		
		<Confirm ref="confirm" />
		
	</v-container>
</template>

<script>
import CustomFieldForm from '@/components/Project/CustomFields/CustomFieldForm';
import CustomFieldsIterator from '@/components/Project/CustomFields/CustomFieldsIterator';
import NewItem from '@/components/NewItem';
import Confirm from '@/components/Confirm';

export default {
	components: {
		CustomFieldForm,
		CustomFieldsIterator,
		NewItem,
		Confirm,
	},

	data() {
		return {
			show: false,
			showEditDialog: false,
			editField: null,
		};
	},
	
	created() {
		this.show = this.project.userCan('view_custom_data');
		if (!this.show) {
			this.$router.replace({ name: 'NotFound' });
		}
	},
	
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		
		customDatas() {
			return this.project.customDatas;
		},
		
		canEdit() {
			return this.project.userCan('manage_custom_data') && !this.project.isArchived;
		},
	},
	methods: {
		updateField(field) {
			this.editField = field;
			this.showEditDialog = true;
		},
		
		disableField(field) {
			const name = field.label;
			const verb = field.disabled ? 'enable' : 'disable';

			this.$refs.confirm.createConfirm(`This will ${verb} "${name}".`, 'error').then((answer) => {
				if (!answer) {
					return;
				}
				field.toggleDisabled().then(() => {
					this.$notify('success', `Field "${name}" has been ${verb}d.`);
				}).catch(() => {
					this.$notify('error', `Failed to ${verb} field "${name}".`);
				});
			});
		},
	},
};
</script>
